import React from "react";
import { PageSeo } from "../components/PageSeo";
import { BanquetSection } from "../components/BanquetSection";

export function BanketSalaPage() {
  return (
    <>
      <PageSeo
        title="Banket sala Kragujevac | RESTORAN KRČMA"
        description="Banket sala RESTORANA KRČMA u Kragujevcu za venčanja, rođendane, krštenja i poslovne proslave."
        keywords="banket sala Kragujevac, sala za proslave Kragujevac, venčanja Kragujevac"
        path="/banket-sala"
      />
      <BanquetSection />
    </>
  );
}

